import "./App.css";
import logo from "./Logo-1.svg";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
// import { Routes, Route } from "react-router-dom";

import MenuBar from "./layouts/menu";
import Footer from "./layouts/Footer";
import Works from "./pages/works";
import Members from "./pages/member";
import Access from "./pages/access";

import Main from "./pages/main";
import Policy from "./pages/policy";

function App(visible) {
  if (visible.inViewport) {
    // Part of the element is in the viewport (the area defined by the offset property)
  } else if (visible.onScreen) {
    // Part of the element is visible on the screen
  } else {
    // Element is no longer visible
  }
  return (
    <div className="App" id="outer-container">
      <div id="page-wrap">
        <header className="wrapper">
          <MenuBar />
          <img className="main-logo" src={logo} alt="logo" />
        </header>

        <div className="cnt-1">
          <AnimationOnScroll animateIn="animate__fadeIn">
            <p className="sub-title">Ignite Again</p>
            <p className="sub-title2">
              この国のエンタメに、もういちど<span className="text-red">火</span>
              を。
            </p>
          </AnimationOnScroll>
          <div className="cnt1-text">
            <AnimationOnScroll animateIn="animate__fadeIn">
              <p>サブスクの登場で、エンターテイメントを</p>
              <p>取り巻く環境は大きく変わった。</p>
              <p>世界中のコンテンツが身近にあるのが当たり前になった今。</p>
              <p>日本の映画やドラマはもう、力を失ってしまったのだろうか。</p>
              <br />
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <p>私たちは思う。</p>
              <p>作品を世界に直接届けられるように</p>
              <p>なった今こそ、打って出る時だと。</p>
              <p>アニメやゲームだけじゃない。</p>
              <br />
              <span className="text-red text-square">◆</span>
            </AnimationOnScroll>
          </div>
          <br />
          <br />
          <div className="cnt1-text">
            <AnimationOnScroll animateIn="animate__fadeIn">
              <p>かつて世界中に影響を与えた日本映画のように、</p>
              <p>ふたたび世界を驚かせるジャパニーズコンテンツが、</p>
              <p>きっとこれから生まれてくる。</p>
              <br />
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <p>自信を失っているヒマなんてない。</p>
              <p>古い常識や慣習に別れを告げて、</p>
              <p>次の時代への一歩を踏み出そう。こんな時代だからこそ、</p>
              <p>エンタメは進化を止めてはいけない。</p>
            </AnimationOnScroll>
          </div>
        </div>

        <Works />
        <Members />
        <Access />
        <Footer />
      </div>
    </div>
  );
}

export default App;
